import React from 'react';
import AMQRCodeStudio from './components/AMQRCodeStudio';
import './App.css';

function App() {
  return (
    <div className="App">
      <AMQRCodeStudio />
    </div>
  );
}

export default App;
